var map = {
	"./Pl3_icon.png": "6581",
	"./Pl5_icon.png": "3c8e",
	"./USMegaMillions.png": "2ea8",
	"./USPowerBall.png": "13c6",
	"./auSaturdayLotto_icon.png": "0cb7",
	"./azxy10_icon.png": "6984",
	"./azxy20.png": "8c43",
	"./azxy5_icon.png": "67bb",
	"./azxy8_icon.png": "68fe",
	"./cannon20_icon.png": "bb4e",
	"./cannon20ex_icon.png": "3468",
	"./euroMillions_icon.png": "fc0e",
	"./gamma3_icon.png": "a7c1",
	"./gamma3ex_icon.png": "71aa",
	"./hklhc_icon.png": "c543",
	"./infinity8_icon.png": "0f39",
	"./infinity8ex_icon.png": "7fb1",
	"./jisukuai3_icon.png": "319e",
	"./jisukuaile_icon.png": "ef5c",
	"./jisusaiche_icon.png": "a2c2",
	"./jisushishi_icon.png": "9e1a",
	"./kl8lhc_icon.png": "37f4",
	"./lucky5_icon.png": "5d6a",
	"./lucky5ex_icon.png": "44db",
	"./lucky7daily_icon.png": "c6a8",
	"./pailie3_icon.png": "d3e1",
	"./pailie5_icon.png": "82be",
	"./penta5_icon.png": "4f9d",
	"./penta5classic_icon.png": "d24b",
	"./penta5ex_icon.png": "e3b4",
	"./penta_icon.png": "63fa",
	"./pl5daily_icon.png": "a710",
	"./qxc_icon.png": "6095",
	"./rolling10_icon.png": "3e35",
	"./rolling10ex_icon.png": "3f6c",
	"./sgplhc_icon.png": "cf82",
	"./surfing10classic_icon.png": "43ef",
	"./twbg_icon.png": "6b7c",
	"./twbglhc_icon.png": "0337",
	"./twbgsch_icon.png": "3c0c",
	"./twbgscq_icon.png": "3721",
	"./twlhc_icon.png": "6ce0",
	"./usMegaMillions_icon.png": "755b",
	"./usPowerBall_icon.png": "295f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e1d8";